require("./individual/header.js");
require("./individual/pricing.js");
require("./individual/home.js");
require("./individual/menu.js");
require("./individual/password.js");
